import { SiTrackPage } from "../../../../components/si-track-page";
import { createEmployeeFormSchema } from "./create-employee-form.schema";
import { SaveEmployeeComponent } from "./save-employee.component";

export const CreateEmployeePage = () => {
    const defaultEmployee: any = {};
    return (
        <SiTrackPage title="Create Employee">
            <SaveEmployeeComponent employee={defaultEmployee} yupSchema={createEmployeeFormSchema} />
        </SiTrackPage>
    );
}